import React from "react";
import { Loader2, User } from "lucide-react";

export const Portrait = ({ src, size = 120, loading, label, gold, testId }) => {
  const ring = gold ? "rgba(255,215,0,0.7)" : "rgba(0,240,255,0.6)";
  return (
    <div className="flex flex-col items-center gap-2" data-testid={testId}>
      <div
        className="relative rounded-full overflow-hidden flex items-center justify-center bg-white/[0.03]"
        style={{ width: size, height: size, border: `2px solid ${ring}`, boxShadow: `0 0 28px ${ring}` }}
      >
        {src ? (
          <img src={src} alt={label || "portrait"} className="w-full h-full object-cover" />
        ) : (
          <User size={size * 0.4} className="text-white/25" />
        )}
        {loading && (
          <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
            <Loader2 className="animate-spin text-amber-300" size={size * 0.25} />
          </div>
        )}
      </div>
      {label && <div className="font-mono-label">{label}</div>}
    </div>
  );
};

export const YearPicker = ({ years, setYears, labelFor }) => (
  <div className="flex gap-2 justify-center flex-wrap" data-testid="year-picker">
    {[10, 25, 40].map((y) => (
      <button
        key={y}
        onClick={() => setYears(y)}
        data-testid={`year-option-${y}`}
        className="text-xs px-3 py-1.5 rounded-full border transition-colors"
        style={{
          borderColor: years === y ? "rgba(255,215,0,0.8)" : "rgba(255,255,255,0.12)",
          color: years === y ? "#FFD700" : "rgba(255,255,255,0.6)",
          background: years === y ? "rgba(255,215,0,0.08)" : "transparent",
        }}
      >
        {labelFor(y)}
      </button>
    ))}
  </div>
);
